var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 49,
    viewBox: "0 0 44 49",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#041A32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.46 1.178c-8.406 0-8.873 5.083-8.285 11.26.59 6.191 4.48 11.258 8.284 11.258 3.807 0 7.696-5.067 8.284-11.257.587-6.178.121-11.261-8.284-11.261z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.136 33.35l-1.168 9.264M19.783 33.35l1.168 9.264M1.178 42.614l.717-9.559c.71-5.277 3.882-5.865 3.882-5.865s3.454-.976 7.122-1.589l2.367 5.507M35.743 34.614l-.72-5.064c-.708-2.795-3.88-3.107-3.88-3.107s-3.455-.517-7.124-.842l-2.28 2.847M10.32 11.306c2.28-3.242 4.688-4.23 7.225-2.962 2.536 1.268 5.676 1.542 9.418.823",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M18.47 34.656l-3.36-3.794 3.34-3.794h.02l3.34 3.794z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M24 40.804l7.973 6.96L43.471 34"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstStep);
export default __webpack_public_path__ + "static/media/firstStep.ef68c39ab366fcfa2f7d4e1eebb14dea.svg";
export { ForwardRef as ReactComponent };